import utils from "@/utilities/Utils";
import { mapData } from "@/utilities/DataMapping";

export interface IProductVariant {
    id: string;
    productID: string;
    description: string;
    isHidden: boolean;
    created: Date;
    createdByUserID: string;
    lastUpdated: Date;
    lastUpdatedByUserID: string;

    guid: string;
}

export class ProductVariant implements IProductVariant {

    constructor(data?: IProductVariant) {
        if (data) this.update(data);
    }

    update(data: IProductVariant): void {
        mapData(data, { root: () => this });
    }

    id: string = utils.emptyGuidValue;
    productID: string = utils.emptyGuidValue;
    description: string = "";
    isHidden: boolean = false;
    created: Date = new Date(utils.emptyDateValue);
    createdByUserID: string = utils.emptyGuidValue;
    lastUpdated: Date = new Date(utils.emptyDateValue);
    lastUpdatedByUserID: string = utils.emptyGuidValue;
        
    guid: string = utils.newGuid();
}
